module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_path.js
// module id = 339
// module chunks = 40